import { PauseCircle } from "lucide-react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function PauseButton({ onClick }: any) {
  return (
    <div className="cursor-pointer" onClick={onClick}>
      <PauseCircle className="h-auto w-[60px] text-white" strokeWidth={1} />
    </div>
  );
}
